import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";
import {Link} from "react-router-dom";

export default function NetvaerksKanalArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <ul className="list list--bullet">
                            <li>
                                <p>
                                    Dit wifi kører over frekvenserne 2,4 og 5 GHz, som har hver deres netværkskanaler.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Din Hiper-router er udstyret med en funktion, der automatisk vælger den mest optimale
                                    netværkskanal
                                    for at undgå interferens fra nærliggende netværk.
                                </p>

                                <ul className="list list--bullet">
                                    <li>
                                        <p>Dette sker typisk, når routeren genstarter eller opdager en dårlig forbindelse på dit 2.4
                                           eller 5 GHz-netværk.</p>
                                    </li>
                                    <li>
                                        <p>Ved at analysere de omkringliggende signaler, kan routeren skifte til en kanal med mindre
                                           trafik, hvilket sikrer en mere stabil forbindelse.</p>
                                    </li>
                                </ul>
                            </li>
                        </ul>

                        <h2 className="heading heading--montserrat heading--medium">
                            Vi anbefaler automatiske frem for specifikke netværkskanaler
                        </h2>
                        <ul className="list list--bullet">
                            <li>
                                <p>
                                    Du kan godt skifte dine netværkskanaler til specifikke kanaler i stedet for automatiske kanaler.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Vi anbefaler dog, at du beholder de automatiske. Det er nemlig ret besværligt at skifte til specifikke netværkskanaler, og det har minimal indflydelse på dit wifi.
                                </p>
                            </li>
                        </ul>
                        <h2 className="heading heading--montserrat heading--medium">
                            Har du ikke et 2,4- og 5 GHz-netværk?
                        </h2>
                        <ul className="list list--bullet">
                            <li>
                                <p>
                                    Så hedder dine to signaler muligvis det samme.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Du kan navngive dine to signaler med to forskellige navne f.eks. kan du kalde dit 2.4 GHz-netværk
                                    “HiperNet” og dit 5 GHz-netværk “HiperNet_5”. <Link to="/hjaelp/internet-og-wifi/skift-navn-og-kode-paa-wifi">Se hvordan du skifter navn på dit 2.4- og 5 GHz-netværk</Link>.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Tips til placering af router"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "skift-navn-og-kode-paa-wifi",
                        "name": "Skift navn og kode på wifi"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forskel-paa-signal-frekvenser",
                        "name": "Forskellen på 2,4- og 5 GHz"
                    }
                ]}
            />
        </>
    )
}
